import React from 'react'
import PropTypes from 'prop-types'
import ReactSelect from 'react-select'
import classnames from 'classnames'
import './SelectInput.scss'
import styles from 'components/Form/Form.scss'

const SelectInput = (props) => {
  const {
    floatedLabel,
    clearable,
    multi,
    disabled,
    handleChange,
    name,
    onBlur,
    options,
    placeholder,
    searchable,
    value,
    error,
  } = props
  const { label, note, valid } = props
  const displayNote = (!valid) ? styles.isHidden : ''
  const hasError = (error.length) ? 'hasError' : ''
  const allowLabel = (!floatedLabel) ? 'disablFloatedLabel' : ''
  const _handleBlur = () => {
    onBlur(name)
  }
  const _handleChange = (option) => {
    handleChange(name, option.value)
  }

  return (
    <div className={classnames('selectBox', allowLabel, hasError)}>
      <ReactSelect
        clearable={clearable}
        multi={multi}
        disabled={disabled}
        name={name}
        onBlur={_handleBlur}
        onChange={_handleChange}
        options={options}
        placeholder={placeholder}
        searchable={searchable}
        value={value}
      />

      <span className="selectBar" />
      {
        label &&
        <span className={classnames('selectLabel', hasError, allowLabel)}>{label}</span>
      }
      {
        note &&
        <span className={classnames(styles.note, displayNote)}>{note}</span>
      }
      {
        error &&
        <span className={classnames(styles.error)}>{error}</span>
      }
    </div>
  )
}

SelectInput.propTypes = {
  label: PropTypes.string,
  floatedLabel: PropTypes.bool,
  name: PropTypes.string.isRequired,
  value: PropTypes.string || PropTypes.number,
  error: PropTypes.string,
  valid: PropTypes.bool,
  disabled: PropTypes.bool,
  handleChange: PropTypes.func.isRequired,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  searchable: PropTypes.bool,
  multi: PropTypes.bool,
  clearable: PropTypes.bool,
  onBlur: PropTypes.func.isRequired,
  note: PropTypes.string,
}

SelectInput.defaultProps = {
  label: '',
  value: '',
  floatedLabel: true,
  error: '',
  valid: true,
  disabled: false,
  placeholder: '',
  searchable: false,
  multi: false,
  clearable: false,
  note: '',
}

export default SelectInput



// WEBPACK FOOTER //
// ./src/components/Form/components/SelectInput/SelectInput.js